import { render, staticRenderFns } from "./DraftOrderShowPage.vue?vue&type=template&id=e665258c&scoped=true&"
import script from "./DraftOrderShowPage.vue?vue&type=script&lang=js&"
export * from "./DraftOrderShowPage.vue?vue&type=script&lang=js&"
import style0 from "./DraftOrderShowPage.vue?vue&type=style&index=0&id=e665258c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e665258c",
  null
  
)

export default component.exports